import { useModuleBEM } from "@b2bportal/core-themes";
import { type IPriceLineItem, CoreUiComponents } from "@b2bportal/core-types";
import clsx from "clsx";
import styles from "./styles.module.scss";

const COMPONENT_KEY = CoreUiComponents.PriceBreakdown;

export const PriceLineItem = ({
  lineTitle,
  baseAmount,
  taxesAndFees,
  icon,
  products,
  className,
}: IPriceLineItem) => {
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);
  return (
    <div className={clsx(block, className)}>
      {lineTitle && (
        <div className={cn("line-item-title")}>
          {icon && <div>{icon}</div>}
          {lineTitle}
        </div>
      )}
      <div className={cn("line-item-detail", { baseAmount: true })}>
        <div className={cn("line-item-label")}>{baseAmount.label}</div>
        <div className={cn("line-item-value")}>{baseAmount.value}</div>
      </div>
      {taxesAndFees ? (
        <div className={cn("line-item-detail", { taxes: true })}>
          <div className={cn("line-item-label")}>{taxesAndFees.label}</div>
          <div className={cn("line-item-value")}>{taxesAndFees.value}</div>
        </div>
      ) : null}
      {products?.map((product, index) => (
        <div
          key={index}
          className={cn("line-item-detail", { [product.type]: true })}
        >
          <div className={cn("line-item-label")}>
            {product.icon && <div>{product.icon}</div>}
            {product.label}
          </div>
          <div className={cn("line-item-value")}>{product.value}</div>
        </div>
      ))}
    </div>
  );
};
